import api from '../../api';
import {handleResponse} from '../../bae/common';
import {showError} from '../../elements/Toasts/toastActions';
import strings from '../../lang/lang';

export async function loadAPiList(any) {
  const { setApiList } = any;
  try {
    const result = await api.portal.getApiList();
    if (Math.floor(result.status / 100) === 2) {
      const response = await handleResponse(result);
      setApiList(response.data);
    } else {
      const response = await result.json();
      showError(response.message);
    }
  } catch (e) {
    console.log('error', e);
    showError(strings.apiCatalogue.errors.retrievingApiData);
  }
}
